import {
  CreateEmailPageTemplatePayload,
  EmailPageTemplateLite,
  UpdateEmailPageTemplatePayload,
} from 'api/email-page-template/types';
import { EmailPageTemplate } from 'api/email-page-template/types';
import { SourceType } from 'api/page-template/types';
import { PageType } from 'api/page-template/types';
import { createPageTemplateHooks } from 'queries/templates';

const emailPageTemplateHooks = createPageTemplateHooks({
  pageType: PageType.Email,
  sourceType: SourceType.Email,
  templateType: {} as EmailPageTemplate,
  templateLiteType: {} as EmailPageTemplateLite,
  createPayloadType: {} as CreateEmailPageTemplatePayload,
  updatePayloadType: {} as UpdateEmailPageTemplatePayload,
});

export const useGetAllEmailPageTemplatesQuery =
  emailPageTemplateHooks.useGetAllTemplatesQuery;
export const useGetEmailPageTemplateQuery =
  emailPageTemplateHooks.useGetTemplateQuery;
export const useCreateEmailPageTemplateMutation =
  emailPageTemplateHooks.useCreateTemplateMutation;
export const useUpdateEmailPageTemplateMutation =
  emailPageTemplateHooks.useUpdateTemplateMutation;
export const useDeleteEmailPageTemplateMutation =
  emailPageTemplateHooks.useDeleteTemplateMutation;
export const useUpdateEmailPageTemplateOrderMutation =
  emailPageTemplateHooks.useUpdateTemplateOrderMutation;
export const useUpdateEmailPageTemplateStatusMutation =
  emailPageTemplateHooks.useUpdateTemplateStatusMutation;
